import { MvpDesignFooter } from 'src/components/Modals/styles';
import Menu from 'src/components/Modals/components/ModalMenu/ModalMenu';
import React from 'react';
import Header from 'src/components/Modals/components/ModalHeader/ModalHeader';
import {
  MvpDesignBodyContainer,
  MvpDesignContentContainer,
  MvpDesignMessageContainer,
} from './MvpAppBody.styles';

interface IMvpAppBody {
  title: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  footer?: JSX.Element;
  message?: string;
  contentMessage?: string;
  isSuccessDialog: boolean;
  isConfirmationDialog?: boolean;
}

const MvpAppBody = ({
  onCancel,
  onConfirm,
  footer,
  title,
  message,
  contentMessage,
  isSuccessDialog,
  isConfirmationDialog,
}: IMvpAppBody) => {
  return (
    <>
      <Header
        isSuccessDialog={isSuccessDialog}
        title={title}
        onClick={onCancel}
      />
      <MvpDesignBodyContainer>
        <MvpDesignMessageContainer>{message}</MvpDesignMessageContainer>
        <MvpDesignContentContainer>{contentMessage}</MvpDesignContentContainer>
        <MvpDesignFooter>
          {footer ||
            ((onConfirm || onCancel || isConfirmationDialog) && (
              <Menu
                isSuccessDialog={isSuccessDialog}
                isConfirmationDialog={isConfirmationDialog}
                onConfirm={onConfirm}
                onCancel={onCancel}
              />
            ))}
        </MvpDesignFooter>
      </MvpDesignBodyContainer>
    </>
  );
};

export default MvpAppBody;
